// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cont_info_Host{
    position: relative;
    display: block;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
}
.top_info_Host{
    position: relative;
    display: block;
    height: 35%;
    width: 100%;
}
.row_info_Host{
    position: relative;
    width: 100%;
    height: 20%;
    display: flex;
    justify-content: start;
    align-items: center;
}
.row_info_Host:nth-child(odd){
    background-color: #f8f9fa;
  }
  .row_info_Host:nth-child(even){
    background-color: #eeeeee;
  }
.title-info_Host{
    position: relative;
    width: 13%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bolder;
    color: #003757d3;
    font-size: large;
}
.txt-info_Host{
    position: relative;
    width: 87%;
    height: 100%;
    display: flex;
    justify-content: start;
    align-items: center;
    color: #414141;
    font-size: medium;
}
.cel_row_info_Host{
        position: relative;
        display: flex;
        width: 25%;
        height: 100%;
}
.cel_row_info_Host:nth-child(even){
    background-color: #f8f9fa;
  }
  .cel_row_info_Host:nth-child(odd){
    background-color: #eeeeee;
  }

  .body_info_Host{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 65%;
  }

  .actBlanco {
    height: 4vh !important;
  }
 
  .info-Host-action:hover{
cursor: pointer;
  }`, "",{"version":3,"sources":["webpack://./src/components/hostManage-components/styles/InfoHost.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,cAAc;IACd,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;AACA;IACI,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;AACF;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,cAAc;IACd,iBAAiB;AACrB;AACA;QACQ,kBAAkB;QAClB,aAAa;QACb,UAAU;QACV,YAAY;AACpB;AACA;IACI,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;;EAEA;AACF,eAAe;EACb","sourcesContent":[".cont_info_Host{\r\n    position: relative;\r\n    display: block;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n.top_info_Host{\r\n    position: relative;\r\n    display: block;\r\n    height: 35%;\r\n    width: 100%;\r\n}\r\n.row_info_Host{\r\n    position: relative;\r\n    width: 100%;\r\n    height: 20%;\r\n    display: flex;\r\n    justify-content: start;\r\n    align-items: center;\r\n}\r\n.row_info_Host:nth-child(odd){\r\n    background-color: #f8f9fa;\r\n  }\r\n  .row_info_Host:nth-child(even){\r\n    background-color: #eeeeee;\r\n  }\r\n.title-info_Host{\r\n    position: relative;\r\n    width: 13%;\r\n    height: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    font-weight: bolder;\r\n    color: #003757d3;\r\n    font-size: large;\r\n}\r\n.txt-info_Host{\r\n    position: relative;\r\n    width: 87%;\r\n    height: 100%;\r\n    display: flex;\r\n    justify-content: start;\r\n    align-items: center;\r\n    color: #414141;\r\n    font-size: medium;\r\n}\r\n.cel_row_info_Host{\r\n        position: relative;\r\n        display: flex;\r\n        width: 25%;\r\n        height: 100%;\r\n}\r\n.cel_row_info_Host:nth-child(even){\r\n    background-color: #f8f9fa;\r\n  }\r\n  .cel_row_info_Host:nth-child(odd){\r\n    background-color: #eeeeee;\r\n  }\r\n\r\n  .body_info_Host{\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 100%;\r\n    height: 65%;\r\n  }\r\n\r\n  .actBlanco {\r\n    height: 4vh !important;\r\n  }\r\n \r\n  .info-Host-action:hover{\r\ncursor: pointer;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
